module.exports = __webpack_public_path__ + "static/media/fision-shirt.99ad5c87.jpg";